'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useApiStore } from '@/context/global/stores/apiStore';
import Header from '@/context/global/components/Layout/Header';
import Footer from '@/context/global/components/Layout/Footer';
import CWAccountSidebar from '@/context/global/components/g00/g00-d00-g009-cw-account-sidebar';
import { useAccountMenuItems } from '@/context/global/hooks/useAccountMenuItems';
import CWSpinner from '@/context/global/components/g00/g00-d00-g005-cw-spinner';
import { useTranslations } from 'next-intl';
import { CWLogoutConfirm } from '@/context/global/components/g00/g00-d00-g012-cw-logout-confirm';

export default function G03D01P003Privacy() {
  const t = useTranslations();
  const router = useRouter();
  const [htmlContent, setHtmlContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const { API } = useApiStore();
  const menuItems = useAccountMenuItems({
    currentPage: 'terms',
    onLogoutClick: () => setShowLogoutConfirm(true),
  });

  useEffect(() => {
    const fetchPrivacy = async () => {
      try {
        const res = await API.User.GetTermPrivacy();
        // API ส่ง HTML มาใน response.data โดยตรง
        setHtmlContent(res.data as string);
      } catch (error) {
        console.error('Failed to load privacy:', error);
        setHtmlContent('<p>Failed to load privacy .</p>');
      } finally {
        setLoading(false);
      }
    };

    fetchPrivacy();
  }, [API]);

  return (
    <div className="text-foreground flex min-h-screen w-full flex-col overflow-x-hidden bg-[#000]">
      <Header />
      <div className="flex h-screen w-full flex-1 overflow-hidden">
        <CWAccountSidebar className="hidden lg:block" menuItems={menuItems} />

        <div className="mt-[100px] flex h-full w-full flex-col px-5 md:mt-[140px] md:px-10">
          {/* Mobile/Tablet Back Navigation */}
          <div className="flex h-11 w-full items-center lg:hidden">
            <button
              type="button"
              onClick={() => router.push('/')}
              className="flex h-full items-center px-2 text-[22px] text-white"
            >
              <span className="mr-1">&lt;</span>
              <span>{t('Common.back')}</span>
            </button>
          </div>
          <h1 className="flex w-full items-center justify-center text-[38px] font-bold md:text-[50px]">
            {t('AccountSidebar.terms')}
          </h1>
          <div className="flex-1">
            {loading ? (
              <div className="flex h-full items-center justify-center">
                <CWSpinner />
              </div>
            ) : (
              <div
                className="policy-content mx-auto max-w-[1300px]"
                dangerouslySetInnerHTML={{ __html: htmlContent }}
              />
            )}
          </div>
        </div>
      </div>
      <Footer />
      <CWLogoutConfirm
        isOpen={showLogoutConfirm}
        onClose={() => setShowLogoutConfirm(false)}
      />
    </div>
  );
}
